import React, { Component } from 'react';
import { scroller } from 'react-scroll';
import Frame from 'react-frame-component';
import PDF from 'react-pdf-pages';
import Document from './components/Document';
import Buttons from './components/Buttons';
import { getPageId } from './helpers/utils';
import { DocumentViewWrapper } from './styled';
import AdvancedLoader from '../AdvancedLoader';
class DocumentView extends Component {
    constructor(props) {
        super(props);
        this.documentWrapperRef = React.createRef();
        this.resizeImages = (val) => {
            const newScale = this.state.actualPdfScale + val;
            const actualZoom = Math.round(newScale * 100);
            if (actualZoom >= 10 && actualZoom <= 200) {
                this.setState({ actualPdfScale: newScale, actualZoom });
            }
        };
        this.scrollTowards = (direction) => {
            const { currentPage } = this.state;
            const nextPage = currentPage + direction;
            this.scrollToPage(nextPage);
        };
        this.scrollToPage = (page) => {
            const { totalPages } = this.state;
            if (page <= totalPages && page > 0) {
                const idx = page - 1;
                scroller.scrollTo(this.pageIds[idx], {
                    containerId: 'document-view',
                    duration: 300,
                    smooth: true,
                });
            }
        };
        this.downloadMenuToggle = () => {
            this.setState((prevState) => ({
                isDownloadMenuOpen: !prevState.isDownloadMenuOpen,
            }));
        };
        this.onComplete = (pdf, item, idx) => {
            if (!this.state.generateIframe && pdf !== this.state.pages && pdf[0]) {
                const newPage = this.state.pages;
                newPage.push({ pdf, idx });
                this.setState({
                    pages: newPage,
                });
                this.handlePages(item.id, pdf[0].file.numPages, idx);
            }
            else {
                this.setState((prevState) => ({
                    renderedDocuments: prevState.renderedDocuments + 1,
                }));
            }
        };
        this.setImageBoxHeight = (ref) => {
            if (ref !== this.imageBoxHeight) {
                this.imageBoxHeight = ref;
            }
        };
        this.printIt = () => {
            const pdfFrame = this.getPrintIframe();
            if (pdfFrame) {
                this.setState({ printing: false }, () => {
                    pdfFrame.focus();
                    pdfFrame.contentWindow.print();
                });
            }
        };
        this.handleScroll = (data) => {
            this.handleScrollDirection(data);
            const imgHeight = this.imageBoxHeight.clientHeight;
            const { currentPage, totalPages, direction } = this.state;
            const heightOfAll = this.documentView.scrollHeight / totalPages;
            const b = heightOfAll * 0.95 * currentPage;
            if (b <= this.documentView.scrollTop &&
                direction === 1 &&
                currentPage < totalPages) {
                this.setState((state) => ({
                    currentPage: state.currentPage + 1,
                }));
            }
            else if (b - imgHeight >= this.documentView.scrollTop &&
                direction === -1 &&
                currentPage > 1) {
                this.setState((state) => ({
                    currentPage: state.currentPage - 1,
                }));
            }
        };
        this.componentWillMount = () => {
            this.documentsList = this.props.documents.converted;
        };
        this.componentDidUpdate = () => {
            const { handleComplete, documents } = this.props;
            if (handleComplete &&
                documents &&
                this.documentsList.length === this.pagesWithData.length) {
                handleComplete();
            }
            if (this.getPrintIframe() &&
                this.state.printing &&
                this.state.renderedDocuments === this.documentsList.length &&
                this.state.totalPages === this.state.renderedImages) {
                this.printIt();
            }
            if (this.documentsList.length === this.pagesWithData.length &&
                this.pageIds.length < this.documentsList.length) {
                this.setPageIds();
            }
            if (this.props.documents.converted && this.props.documents.cert) {
                this.documentsList = this.props.documents.converted.concat(this.props.documents.cert);
                this.handleScroll(this.documentsList.length - 1);
            }
            else if (this.props.documents.converted) {
                this.documentsList = this.props.documents.converted;
            }
        };
        this.handlePages = (documentId, newPagesCount, idx) => {
            this.pagesWithData.push({
                id: idx,
                pageIds: Array(newPagesCount).map((_, i) => getPageId(documentId, i)),
            });
            this.setState((prevState) => ({
                totalPages: prevState.totalPages + newPagesCount,
            }));
        };
        this.setPageIds = () => {
            const sortedPagesIds = this.pagesWithData.sort((a, b) => {
                if (a.id < b.id)
                    return -1;
                if (a.id > b.id)
                    return 1;
                return 0;
            });
            if (this.pageIds.length < sortedPagesIds.length) {
                sortedPagesIds.forEach((item) => {
                    this.pageIds = this.pageIds.concat(item.pageIds);
                });
            }
            this.pageIds = this.pageIds.filter((item, idx) => this.pageIds.indexOf(item) === idx);
        };
        this.getPrintIframe = () => document.querySelector('.PrintFrame iframe');
        this.handlePrint = () => {
            const { beforePrint } = this.props;
            if (beforePrint)
                beforePrint();
            if (!this.getPrintIframe()) {
                this.setState({ generateIframe: true, printing: true });
            }
            else {
                this.setState({ printing: true });
            }
        };
        this.saveDocumentInfo = () => {
            const { handleDocumentInfo } = this.props;
            const documentInfo = [];
            if (this.documentWrapperRef.current) {
                const arr = Array.from(this.documentWrapperRef.current.children);
                arr.shift();
                arr.forEach((item, idx) => {
                    const pageStartX = item.offsetLeft;
                    const pageStartY = item.offsetTop;
                    const pageStopX = item.offsetLeft + item.offsetWidth;
                    const pageStopY = item.offsetTop + item.offsetHeight;
                    documentInfo.push({
                        pageStartX,
                        pageStartY,
                        pageStopX,
                        pageStopY,
                        offsetWidth: item.offsetWidth,
                        offsetHeight: item.offsetHeight,
                        page: idx,
                    });
                });
            }
            if (handleDocumentInfo) {
                handleDocumentInfo(documentInfo);
            }
        };
        this.onPageComplete = (pdf, page, renderImage) => {
            if (renderImage && this.state.renderedImages !== this.state.totalPages) {
                this.setState((prevState) => ({
                    renderedImages: prevState.renderedImages + 1,
                }));
            }
            else {
                this.setState((prevState) => ({
                    renderedCanvas: prevState.renderedCanvas + 1,
                }));
            }
            this.saveDocumentInfo();
        };
        this.onTouchStart = () => {
            clearTimeout(this.timeout);
            this.setState({ isTapped: true });
        };
        this.onTouchEnd = () => {
            this.timeout = setTimeout(() => this.setState({ isTapped: false }), 2000);
        };
        this.areDocumentsConverted = () => this.documentsList.length === this.pagesWithData.length;
        this.state = {
            imagesWidth: 0,
            currentPage: 1,
            totalPages: 0,
            actualZoom: 100,
            actualPdfScale: 1,
            isDownloadMenuOpen: false,
            direction: 0,
            lastScrollPos: 0,
            pageIds: [],
            pages: [],
            generateIframe: false,
            renderedImages: 0,
            renderedDocuments: 0,
            printing: false,
            renderedCanvas: 0,
            isTapped: false,
        };
        this.offset = [];
        this.imageBoxHeight = 0;
        this.pageIds = [];
        this.pagesWithData = [];
        this.documentsList = [];
    }
    handleScrollDirection(lastScrollPos) {
        if (this.state.lastScrollPos > lastScrollPos) {
            this.setState({
                direction: -1,
                lastScrollPos,
            });
        }
        else if (this.state.lastScrollPos < lastScrollPos) {
            this.setState({
                direction: +1,
                lastScrollPos,
            });
        }
    }
    render() {
        const { documents, showButtons, className, id, translation, showTitle, title, description, viewer, stampRef, completed, isEnterprise, } = this.props;
        const { imagesWidth, actualZoom, currentPage, totalPages, isDownloadMenuOpen, generateIframe, pages, renderedCanvas, isTapped, } = this.state;
        const t = translation;
        const canShowLoader = documents &&
            renderedCanvas === 0 &&
            this.documentsList.length !== this.pagesWithData.length;
        const documentBox = (iframe) => {
            if (documents.converted && this.documentsList.length > 0) {
                return this.documentsList.map((item, i) => {
                    const idx = pages.findIndex((item) => item.idx === i);
                    return (React.createElement(PDF, Object.assign({}, item, { url: item.url, key: item.id, onComplete: (pages) => this.onComplete(pages, item, i), className: "col" }), pages[idx] && (React.createElement(Document, Object.assign({}, item, { pages: pages[idx].pdf, imagesWidth: imagesWidth, actualZoom: actualZoom, id: this.documentsList[i].id, fileName: item.filename, order: i, setImageBoxHeight: this.setImageBoxHeight, forPrint: iframe, onPageComplete: this.onPageComplete, title: title, description: description, showTitle: showTitle, stampRef: stampRef, documentWrapperRef: this.documentWrapperRef })))));
                });
            }
            return null;
        };
        return (React.createElement(DocumentViewWrapper, { className: `DocumentView ${className} ${canShowLoader ? 'loading' : ''} `, onTouchStart: this.onTouchStart, onTouchEnd: this.onTouchEnd },
            React.createElement("div", { id: id, ref: (node) => (this.documentView = node), className: "documents-container page-dropzone", onScroll: (event) => {
                    this.handleScroll(event.currentTarget.scrollTop);
                } },
                canShowLoader && React.createElement(AdvancedLoader, { absolute: true, text: t.loadingText }),
                documents && documentBox(),
                generateIframe && (React.createElement("div", { className: "PrintFrame" },
                    React.createElement(Frame, null, documentBox(true))))),
            showButtons &&
                totalPages > 0 &&
                renderedCanvas > 0 &&
                this.areDocumentsConverted() && (React.createElement(Buttons, { currentPage: currentPage, totalPages: totalPages, actualZoom: actualZoom, isDownloadMenuOpen: isDownloadMenuOpen, documents: documents, translation: translation, resizeImages: this.resizeImages, scrollTowards: this.scrollTowards, scrollToPage: this.scrollToPage, downloadMenuToggle: this.downloadMenuToggle, handlePrint: this.handlePrint, isTapped: isTapped, viewer: viewer, isEnterprise: isEnterprise, completed: completed }))));
    }
}
DocumentView.defaultProps = {
    className: '',
};
export default DocumentView;
